<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 8L11 8" stroke="#F9F2EC" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 5L11.9167 7.91667L9 10.8333" stroke="#F9F2EC" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  